import React, { useState } from 'react';
import ManageTopping from '../../../../../components/ManageTopping';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import ReactModal from '../../../../../components/ReactModal';
import { COLORS } from '../../../../../utils/colors';

const TreeToppingElement = (props) => {
  const { topping, fromToppingGroupId } = props;
  const [toppingModalIsOpen, setToppingModalIsOpen] = useState(false);

  const handleToppingClick = () => {
    setToppingModalIsOpen(true);
  };

  const square = '30px';

  const isExtraToppingGroupTopping = fromToppingGroupId !== topping.toppings_group_id;

  const smallWindow = window.innerWidth < 500;

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          opacity: topping.active ? 1 : 0.3,
          fontSize: '0.8rem',
          padding: '6px 3px',
          borderRadius: '3px',
          marginLeft: smallWindow ? '-22px' : 'auto',
        }}
        onClick={handleToppingClick}
      >
        {!isExtraToppingGroupTopping ? (
          <div
            style={{
              fontWeight: 'normal',
              letterSpacing: '-0.024em',
              marginRight: '10px',
              fontSize: '0.64rem',
              minWidth: '16px',
            }}
          >
            {topping.position}
          </div>
        ) : (
          <DoubleArrowIcon className="s-24-i txt-info" style={{ margin: '0 10px 0 -15px' }} />
        )}
        <div
          style={{
            width: square,
            height: square,
            background: COLORS.MUI_BLUE,
            borderRadius: '4px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <span style={{ fontSize: '20px', fontWeight: 'bold', color: 'white' }}>T</span>
        </div>
        <div style={{ letterSpacing: '-0.024em', marginLeft: '10px' }}>{topping.name}</div>
        <div
          style={{
            fontWeight: 'bold',
            letterSpacing: '-0.024em',
            marginLeft: '5px',
            textAlign: 'right',
          }}
        >
          {topping.cost}
        </div>
      </div>
      {toppingModalIsOpen && (
        <ReactModal modalIsOpen={toppingModalIsOpen} setIsOpen={setToppingModalIsOpen}>
          <ManageTopping
            type="edit"
            toppingId={topping.id}
            toppingGroupId={topping.toppings_group_id}
            onClose={() => setToppingModalIsOpen(false)}
          />
        </ReactModal>
      )}
    </div>
  );
};

export default TreeToppingElement;
